import R from "ramda";
import {
  WorkStationIotServiceProxy,
  GatewayAppServiceProxy,
  IothubPropertyServiceProxy,
  IothubParameterServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import {IotAppServiceProxy, IotAppSettingServiceProxy} from '@/service-proxies/app-v2/iot-console.service-proxies'

const iotService = new WorkStationIotServiceProxy();
const gatewayAppService = new GatewayAppServiceProxy();
const iothubPropertyService = new IothubPropertyServiceProxy();
const iothubParamterService = new IothubParameterServiceProxy();
const iasp = new IotAppServiceProxy();
const iassp = new IotAppSettingServiceProxy();

export enum Types {
  create = "create",
  edit = "edit",
}

export enum Codes {
  空,
  机器,
  人工,
}

export const WORK_STATION_TYPE = "work_station_type";

const CascaderFuncs = {
  iots: iotService.getIotsByWorkstationId.bind(iotService),
  iotAppOptions: gatewayAppService.queryGatewayAppList.bind(gatewayAppService),
  newIotAppOptions: R.curry(iasp.getIotAppList.bind(iasp))(undefined, R.__, undefined),
  iotAppParamOptions: R.curry(
    iothubPropertyService.queryGatewayAppProperties.bind(iothubPropertyService)
  )(1, R.__, -1),
  newIotAppParamOptions: iassp.getIotAppSettingList.bind(iassp),
};

export const getCascaderFunction = R.prop(R.__, CascaderFuncs);

export enum IotTypes {
  IotConfig,
  AppConfig,
  AppCreate,
  PropCreate,
  PropModify,
}

export enum TabTypes {
  Left,
  Right,
}

export const addressTypes = [
  "bit",
  "uint8",
  "uint16",
  "uint32",
  "uint64",
  "int8",
  "int16",
  "int32",
  "int64",
  "real4",
  "real8",
  "string",
  "datetime",
  "AlarmInfo",
  "AlarmArray",
  "any",
];

export const fetchFnsMap = {
  [IotTypes.IotConfig]: iothubParamterService.getGatewayParams.bind(
    iothubParamterService
  ),
  [IotTypes.AppConfig]: iothubParamterService.getGatewayAppParams.bind(
    iothubParamterService
  ),
  [IotTypes.AppCreate]: gatewayAppService.queryGatewayAppTypeList.bind(
    gatewayAppService
  ),
  [IotTypes.PropCreate]: iothubPropertyService.queryAddressInfo.bind(
    iothubPropertyService
  ),
  [IotTypes.PropModify]: iothubPropertyService.queryAddressInfo.bind(
    iothubPropertyService
  ),
};

export const submitFnsMap = {
  [IotTypes.IotConfig]: iothubParamterService.setMultipleGatewayParams.bind(
    iothubParamterService
  ),
  [IotTypes.AppConfig]: iothubParamterService.setMultipleGatewayParams.bind(
    iothubParamterService
  ),
  [IotTypes.AppCreate]: gatewayAppService.create.bind(gatewayAppService),
  [IotTypes.PropCreate]: iothubPropertyService.updateProperty.bind(
    iothubPropertyService
  ),
  [IotTypes.PropModify]: iothubPropertyService.updateProperty.bind(
    iothubPropertyService
  ),
};

export const deleteFnsMap = {
  app: gatewayAppService.delete.bind(gatewayAppService),
  prop: iothubPropertyService.delProperty.bind(iothubPropertyService),
};

export enum ACLS {
  CREATE_WORKSTATION = "page_workstation_maintain_create_workstation",
  DELETE_WORKSTATION = "page_workstation_maintain_delete_workstation",
  EDIT_WORKSTATION = "page_workstation_maintain_edit_workstation",
  CREATE_PARAM = "page_workstation_maintain_create_param",
  EDIT_PARAM = "page_workstation_maintain_edit_param",
  DELETE_PARAM = "page_workstation_maintain_delete_param",
  EXPORT_PARAM = "page_workstation_maintain_export_param",
  IMPORT_PARAM = "page_workstation_maintain_import_param",
  ADD_RELATE = "page_workstation_maintain_add_relate",
  CANCEL_RELATE = "page_workstation_maintain_cancel_relate",
  CONFIG_IOT = "page_workstation_maintain_config_iot",
  CREATE_APP = "page_workstation_maintain_create_app",
  DELETE_APP = "page_workstation_maintain_delete_app",
  CONFIG_APP = "page_workstation_maintain_config_app",
  CREATE_PROP = "page_workstation_maintain_create_prop",
  DELETE_PROP = "page_workstation_maintain_delete_prop",
  EDIT_PROP = "page_workstation_maintain_edit_prop",
  LIVE_DATA = "page_workstation_maintain_live_data",
  CONFIG_TRANSFER = "page_workstation_maintain_config_transfer",
  EXPORT_MODEL = "page_workstation_maintain_export_model",
  INPOERT_MODEL = "page_workstation_maintain_inport_model",
  EXPORT_DMP = "page_workstation_maintain_export_dmp",
  IMPORT_DMP = "page_workstation_maintain_import_dmp",
}

export enum Access {
  readonly = 1,
  readwrite = 2,
}
